export const retrieveMaxAgeHeader = (headers) => {
  const cacheControl = headers?.get("cache-control") || headers?.get("Cache-control ");

  if (cacheControl) {
    const maxAgeMatch = cacheControl.match(/max-age=(\d+)/);

    if (maxAgeMatch) {
      const maxAgeSeconds = parseInt(maxAgeMatch[1], 10);

      if (maxAgeSeconds === 0 || cacheControl.includes("no-store")) {
        return null;
      }

      return Math.floor((Date.now() + maxAgeSeconds * 1000) / 1000).toString();
    }
  }

  return null;
};
